import React from "react";
import Testimonials from "../home/Testimonials";

const ChannelTestimonials = () => {
  return <Testimonials />;
};

export default ChannelTestimonials;
